import React from 'react';

/*
 * ShareWin — a small "share your win" widget. Opens prefilled share intents for X
 * and LinkedIn so a candidate can celebrate a milestone (and seed AutoHire's brand)
 * in one click. Pass an optional `message` to override the default copy.
 */
function ShareWin({ message }) {
  const text = message || 'I just landed an interview via AutoHire 🎉';
  const shareUrl =
    typeof window !== 'undefined' ? window.location.origin : 'https://autohire.tech';

  const xUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
  const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
    shareUrl
  )}`;

  const open = (url) => window.open(url, '_blank', 'noopener,noreferrer');

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5">
      <h3 className="text-sm font-semibold text-gray-900">Share your win</h3>
      <p className="mt-1 text-sm text-gray-500">{text}</p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button
          type="button"
          onClick={() => open(xUrl)}
          className="inline-flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2 text-sm font-semibold text-white hover:bg-black"
        >
          Share on X
        </button>
        <button
          type="button"
          onClick={() => open(linkedInUrl)}
          className="inline-flex items-center gap-2 rounded-lg bg-[#2563EB] px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
        >
          Share on LinkedIn
        </button>
      </div>
    </div>
  );
}

export default ShareWin;
